import axios from 'axios';

export const translateText = async (text, targetLang = 'en') => {
    if (!text || typeof text !== 'string') return text;

    try {
        const response = await axios.get(
            `https://translate.googleapis.com/translate_a/single?client=gtx&sl=auto&tl=en&dt=t&q=${encodeURIComponent(text)}`
        );

        if (response.data?.[0]) {
            const fullTranslation = response.data[0].map(segment => segment[0]).join('');
            return fullTranslation;
        }
        return text;
    } catch (error) {
        console.error('Translation error:', error);
        return text;
    }
};

export const useTranslationService = () => {
    return {
        translateText
    };
};